import React from "react";

import { Typography } from "../Typography";

import type { ReactNode } from "react";
import type { TypographyProps } from "../Typography";

export interface CheckboxLabelProps extends TypographyProps {
  children: string | ReactNode; // used for the component that is associated with the label
}

export const CheckboxLabel: React.FC<CheckboxLabelProps> = ({
  children,
  color,
  style,
  ...props
}) => {
  return (
    <Typography
      variation="semibold.title.six"
      style={style}
      {...props}
      accessibilityRole="text"
      color={color ? color : "inputLabelText"}
    >
      {children}
    </Typography>
  );
};

export const RadioLabel = CheckboxLabel;
export const SwitchLabel = CheckboxLabel;
export const UploadFieldLabel = CheckboxLabel;
